<template>
  <v-app id="user" v-if="isAuthed" class="transparent">
    <user-navigator ref="navigator"></user-navigator>
    <user-toolbar @emit="emitted"></user-toolbar>
    <v-content>
      <v-container app fill-height>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import UserToolbar from './toolbar'
import UserNavigator from './navigator'

export default {
  name: 'user',
  components: {
    UserToolbar,
    UserNavigator
  },
  data () {
    return {
      config: {
        status: {
          navigator: true,
          authed: true
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.axios.post(this.$url.api + 'user/init', {}, {
        headers: {
          'user-token': this.$localStorage.get('jwt')
        }
      }).then(res => {
        console.log(res.data.data)
        this.$store.commit('user/update', res.data.data)
      })
    },
    emitted: function (req) {
      if (
        req &&
        req.dest &&
        req.action &&
        this.$refs[req.dest] &&
        typeof this.$refs[req.dest][req.action] === 'function'
      ) {
        this.$refs[req.dest][req.action](req.data)
      }
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    }
  }
}
</script>

<style lang="scss">
#user {
  .container.app {
    & > main {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
